import React from 'react'

// MUI Components
import { Box, Typography, Divider } from '@mui/material'

// Icons
import { VerifiedCIcon, NotVerifiedCIcon } from '~/assets/images'

// Utils
import { formatDateOnly } from '~/utils/date-format';

// Styles
import './styles.scss';

const getAddressStatusDisplay = (status) => {
    const isVerified = status === 'Verified';
    const isCorrected = status === 'Corrected';
    const isFailed = status === 'Failed';
    const shouldShowIcon = isVerified || isCorrected || isFailed;
    
    return {
        icon: shouldShowIcon ? (isVerified || isCorrected ? VerifiedCIcon : NotVerifiedCIcon) : null,
        color: isVerified || isCorrected ? '#10B981' : isFailed ? '#FF0000' : '',
        text: isVerified ? 'Verified' : isCorrected ? 'Corrected' : isFailed ? 'Failed' : status || '-',
        showIcon: shouldShowIcon
    };
};

const MailingTab = ({ orignalContactData }) => {
    const statusDisplay = getAddressStatusDisplay(orignalContactData?.addressStatus);
    
    return (
        <Box className="mailingTabContent">
            {/* Mailing Address Section */}
            <Box className="mailingSection">
                <Box className="addressGrid">
                    <Box className="addressRow">
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Mailing Address 1</Typography>
                            <Typography className="addressValue">
                                {orignalContactData?.address1 || '14 Granger Dr'}
                            </Typography>
                        </Box>
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Mailing Address 2</Typography>
                            <Typography className="addressValue">
                                {orignalContactData?.address2 || '-'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box className="addressRow">
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Mailing City</Typography>
                            <Typography className="addressValue">
                                {orignalContactData?.city || 'Seattle'}
                            </Typography>
                        </Box>
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Mailing State</Typography>
                            <Typography className="addressValue">
                                {orignalContactData?.state || 'WA'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box className="addressRow">
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Mailing Zip Code</Typography>
                            <Typography className="addressValue">
                                {orignalContactData?.zip || '01030-1622'}
                            </Typography>
                        </Box>
                        <Box className="addressColumn">
                            <Typography className="addressLabel">Address Status</Typography>
                            <Box className="statusContainer">
                                {statusDisplay.showIcon && (
                                    <Box className="statusIcon">
                                        <img src={statusDisplay.icon} alt="status" />
                                    </Box>
                                )}
                                <Typography className="statusValue" sx={{ color: statusDisplay.color }}>
                                    {statusDisplay.text}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Divider />

            {/* Mailing Activity Section */}
            <Box className="mailingSection">
                <Box className="activityGrid">
                    <Box className="activityRow">
                        <Box className="activityColumn">
                            <Typography className="activityLabel">Total Mailed</Typography>
                            <Typography className="activityValue">
                                {orignalContactData?.totalMailed || '-'}
                            </Typography>
                        </Box>
                        <Box className="activityColumn">
                            <Typography className="activityLabel">Last Mailed Status</Typography>
                            <Typography className="activityValue">
                                {orignalContactData?.lastMailedStatus || '-'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box className="activityRow">
                        <Box className="activityColumn">
                            <Typography className="activityLabel">Last Mailed Date</Typography>
                            <Typography className="activityValue">
                                {orignalContactData?.lastMailedDate
                                    ? formatDateOnly(new Date(orignalContactData.lastMailedDate))
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default MailingTab